import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container my-12 mx-auto px-4" }
const _hoisted_2 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute top-0 right-0 -mt-3 mr-3" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_6 = { class: "background: #e5e7eb26;" }
const _hoisted_7 = { class: "text-white text-lg font-bold leading-tight mb-3 pr-5" }
const _hoisted_8 = { class: "flex w-full items-center text-sm text-gray-300 font-medium" }
const _hoisted_9 = { class: "flex-1 flex items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-thumb-up" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "object-center h-24 w-24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.items)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "m-3",
              onClick: ()=> _ctx.selectItem(item)
            }, [
              _createElementVNode("a", {
                href: "#",
                class: _normalizeClass(["block rounded-lg relative p-4 transform transition-all duration-300 scale-100 hover:scale-95", {'bg-gray-400' : !item.thumbnailAbsoluteUrl}]),
                style: _normalizeStyle([item.thumbnailAbsoluteUrl ? {'background-image': `url(${item.thumbnailAbsoluteUrl})`, 'background-position':'center', 'background-size': 'cover'}: {}])
              }, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h2", _hoisted_7, _toDisplayString(item.songTitle), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["rounded-full w-8 h-8 mr-3", {'bg-gray-500' : !item.thumbnailAbsoluteUrl}]),
                        style: _normalizeStyle([item.thumbnailAbsoluteUrl ? {'background-image': `url(${item.thumbnailAbsoluteUrl})`, 'background-position':'center', 'background-size': 'cover'} : {} ])
                      }, null, 6),
                      _createElementVNode("div", null, _toDisplayString(item.bandName), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(item.totalVerses), 1)
                    ])
                  ])
                ])
              ], 6)
            ], 8, _hoisted_3))
          }), 128))
        : (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.label_no_results), 1))
    ])
  ]))
}